import { render } from "./CategoryView.vue?vue&type=template&id=0d082096"
import script from "./CategoryView.vue?vue&type=script&lang=js"
export * from "./CategoryView.vue?vue&type=script&lang=js"

import "./CategoryView.vue?vue&type=style&index=0&id=0d082096&lang=css"

import exportComponent from "D:\\도연희\\vuestudy\\vue-noelo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__